/*
  cinema-tour-live.js
  Re-evaluates Automatik (OneLive tour app) tour rows and ticket buttons in
  the browser. Liquid renders a first pass, but Shopify caches pages, so
  "now" at render time can be stale — so publish/remove checks are
  repeated here in JS.

  Hooks (all output by Liquid):
    [data-ctl-root]          section wrapper
    [data-ctl-leg]           leg/tour group (inner page)
    [data-ctl-row]           one event row, data-ctl-event = unix seconds
    [data-ctl-cta]           one button, see snippets/cinema-tour-live-cta.liquid

  Testing: append ?preview_date=2027-01-15T10:00:00 to the URL to simulate
  a date. ?ctl_debug=1 logs every decision.
*/
(function () {
  'use strict';

  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  var params = new URLSearchParams(window.location.search);
  var DEBUG = params.get('ctl_debug') === '1';

  function log() {
    if (DEBUG) console.log.apply(console, ['[cinema-tour]'].concat([].slice.call(arguments)));
  }

  // Current time in unix seconds, honoring ?preview_date=
  function getNow() {
    var preview = params.get('preview_date');
    if (preview) {
      var d = new Date(preview);
      if (!isNaN(d.getTime())) {
        console.log('[cinema-tour] PREVIEW MODE — simulating', d.toISOString());
        return Math.floor(d.getTime() / 1000);
      }
      console.warn('[cinema-tour] Invalid preview_date:', preview);
    }
    return Math.floor(Date.now() / 1000);
  }

  // "14 NOV" — matches the Liquid '%-d %b' | upcase output
  function formatOnSale(ts) {
    var d = new Date(ts * 1000);
    return d.getDate() + ' ' + MONTHS[d.getMonth()];
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function applyCta(el, now) {
    var pub = parseInt(el.dataset.publish, 10) || 0;
    var rem = parseInt(el.dataset.remove, 10) || 0;
    var sold = el.dataset.soldout === '1';
    var label = el.dataset.label || '';

    // Precedence: sold out > removed > not yet published > live
    var state = 'live';
    if (sold) state = 'soldout';
    else if (rem && rem < now) state = 'ended';
    else if (pub && pub > now) state = 'pending';

    // Two-line label: everything but the last word on line one, the last
    // word on line two with the date or ENDED after it.
    var words = label.trim().split(/\s+/);
    var lbl2 = words.length > 1
      ? esc(words.slice(0, -1).join(' ')) + '<br>' + esc(words[words.length - 1])
      : esc(label);
    if (state === 'soldout') el.textContent = 'SOLD OUT';
    else if (state === 'ended') el.innerHTML = lbl2 + ' <small>ENDED</small>';
    else if (state === 'pending') el.innerHTML = lbl2 + ' <small>' + formatOnSale(pub) + '</small>';
    else el.innerHTML = lbl2;
    el.dataset.state = state;

    if (el.dataset.mod) el.classList.toggle(el.dataset.mod, state === 'live');
    if (el.dataset.off) el.classList.toggle(el.dataset.off, state !== 'live');

    if (state === 'live' && el.dataset.href) {
      el.setAttribute('href', el.dataset.href);
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener');
      el.removeAttribute('aria-disabled');
    } else {
      el.removeAttribute('href');
      el.removeAttribute('target');
      el.setAttribute('aria-disabled', 'true');
    }

    log('cta', label, '→', state, { publish: pub, remove: rem, sold: sold });
  }

  function run(scope) {
    var root = scope || document;
    var now = getNow();
    var sections = root.querySelectorAll('[data-ctl-root]');

    sections.forEach(function (section) {
      // Hide rows whose event start has passed (page may be cached from earlier)
      section.querySelectorAll('[data-ctl-row]').forEach(function (row) {
        var eventTs = parseInt(row.dataset.ctlEvent, 10) || 0;
        row.hidden = eventTs > 0 && eventTs < now;
      });

      section.querySelectorAll('[data-ctl-cta]').forEach(function (el) {
        applyCta(el, now);
      });

      // GET ACCESS (subscriber-only slots for non-members): drops out when the
      // presale closes, same as the buttons. Class rather than [hidden] so it
      // keeps its grid columns on desktop and the other buttons stay aligned.
      section.querySelectorAll('[data-ctl-access]').forEach(function (el) {
        var rem = parseInt(el.dataset.remove, 10) || 0;
        el.classList.toggle('is-closed', rem > 0 && rem < now);
      });

      // Collapse legs that no longer have upcoming rows
      section.querySelectorAll('[data-ctl-leg]').forEach(function (leg) {
        var visible = leg.querySelectorAll('[data-ctl-row]:not([hidden])').length;
        leg.hidden = visible === 0;
      });

      var total = section.querySelectorAll('[data-ctl-row]:not([hidden])').length;
      var empty = section.querySelector('[data-ctl-empty]');
      if (empty) empty.hidden = total > 0;

      console.log('[cinema-tour] section', section.dataset.ctlRoot, '— upcoming rows visible:', total);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  // Theme editor: re-run when a section is added/re-rendered
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();